import React, { useEffect, useState } from "react";
import { Check, Loader2, FileText } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import api, { apiError, arr } from "@/lib/api";
import PageHeader from "@/components/common/PageHeader";

export default function Plans() {
  const [plans, setPlans] = useState([]);
  const [edit, setEdit] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/admin/plans").then(({ data }) => setPlans(arr(data)));
  useEffect(() => { load(); }, []);

  const save = async () => {
    setSaving(true);
    try {
      await api.put(`/admin/plans/${edit._id}`, { price: Number(edit.price), limits: edit.limits });
      toast.success("Plan updated");
      setEdit(null);
      load();
    } catch (err) { toast.error(apiError(err)); } finally { setSaving(false); }
  };

  return (
    <div className="space-y-6">
      <PageHeader title="Plans" subtitle="Subscription plans offered to clients" icon={FileText} />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {plans.map((p) => (
          <div key={p._id} className="card-surface card-hover flex flex-col p-6">
            <p className="text-overline">{p.name}</p>
            <p className="mt-2 font-heading text-3xl font-bold text-slate-900">₹{p.price.toLocaleString()}<span className="text-sm font-normal text-slate-400">/mo</span></p>
            <ul className="mt-4 flex-1 space-y-2">
              {arr(p.features).map((f, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-slate-600"><Check className="mt-0.5 h-4 w-4 shrink-0 text-green-500" /> {f}</li>
              ))}
            </ul>
            <Button variant="outline" className="mt-5 rounded-xl" onClick={() => setEdit({ ...p })} data-testid={`edit-plan-${p.name}`}>Edit plan</Button>
          </div>
        ))}
      </div>

      <Dialog open={!!edit} onOpenChange={() => setEdit(null)}>
        <DialogContent className="max-w-md rounded-2xl">
          <DialogHeader><DialogTitle>Edit {edit?.name} plan</DialogTitle></DialogHeader>
          {edit && (
            <div className="space-y-4">
              <div><label className="mb-1 block text-xs font-medium text-slate-600">Price (₹/month)</label><input type="number" className="h-10 w-full rounded-xl border border-slate-200 bg-slate-50 px-3 text-sm" value={edit.price} onChange={(e) => setEdit({ ...edit, price: e.target.value })} /></div>
              <div className="grid grid-cols-2 gap-3">
                {["posts", "reviewRequests", "aiReplies", "locations"].map((k) => (
                  <div key={k}><label className="mb-1 block text-xs font-medium capitalize text-slate-600">{k}</label><input type="number" className="h-10 w-full rounded-xl border border-slate-200 bg-slate-50 px-3 text-sm" value={edit.limits[k]} onChange={(e) => setEdit({ ...edit, limits: { ...edit.limits, [k]: Number(e.target.value) } })} /></div>
                ))}
              </div>
            </div>
          )}
          <DialogFooter>
            <Button variant="outline" className="rounded-xl" onClick={() => setEdit(null)}>Cancel</Button>
            <Button onClick={save} disabled={saving} className="rounded-xl bg-brand-700 text-white hover:bg-brand-800">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Save"}</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
